import React from 'react';
import { useSelector } from 'react-redux';
import { IconButton } from '../../../CommonComponents/OPL/IconButton/IconButton';
import { toast } from '../../../CommonComponents/OPL/Toast/Toast';
import { Tooltip } from '../../../CommonComponents/OPL/Tooltip/Tooltip';
import { MESSAGES } from '../../../CommonConstants';
import { selectCanExportPersonalFinancesToCsv } from '../../../CommonSelectors/CommonAreaSelector';
import { downloadFile } from '../../../CommonUtils/downloadFile';
import { useUnrealizedGainLossCsvMutation } from '../../api/useUnrealizedGainLossCsvMutation';
import { usePositionsDate } from '../../hooks/usePositionsDate';
import { useRouteParams } from '../../hooks/useRouteParams';

interface Props {
  selectedGroupName: string;
}

export const UnrealizedGainLossCsvExport = (props: Props) => {
  const canExportPersonalFinancesToCsv = useSelector(selectCanExportPersonalFinancesToCsv);

  if (!canExportPersonalFinancesToCsv) {
    return null;
  }

  return <Content {...props} />;
};

const Content = ({ selectedGroupName }: Props) => {
  const { clientId, accountId, groupId } = useRouteParams();

  const date = usePositionsDate();

  const {
    mutateAsync: downloadCsv,
    isLoading: isDownloadingCsv,
  } = useUnrealizedGainLossCsvMutation();

  const onDownloadCsv = async () => {
    try {
      const { fileName, fileBlob } = await downloadCsv({
        clientId,
        date,
        accountId,
        groupId,
        selectedGroupName,
      });

      downloadFile(fileName || 'unrealized_gainloss.csv', fileBlob);
    } catch (error) {
      console.error(error);
      toast.error(MESSAGES.GENERIC_ERROR);
    }
  };

  return (
    <Tooltip content="Export to Excel" placement="bottom-start" delay={500}>
      <IconButton
        icon="far fa-file-export"
        variant="secondary"
        aria-label="Export to Excel"
        isLoading={isDownloadingCsv}
        onClick={onDownloadCsv}
      />
    </Tooltip>
  );
};
